// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExtendedTestimonials_wrapper__34wcS","hide":"ExtendedTestimonials_hide__nXx7U"};